import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core'
import { SelectionChange, SelectionModel } from '@angular/cdk/collections'
import { CheckboxComponent } from '@ui/Components/Form/Checkbox/Checkbox.Component'
import ListItem from '@ui/ListItem'

export interface CheckboxValueChange {
	instance: ListItem
	checked: boolean
}

@Component({
	selector: 'table-cell-checkbox',
	templateUrl: './TableCellCheckbox.Component.html',
	imports: [CheckboxComponent],
})
export class TableCellCheckboxComponent implements OnInit, OnChanges {
	@Input() public instance: ListItem

	@Input() public disabled: boolean

	@Output() public handleToggle = new EventEmitter<CheckboxValueChange>()

	@Input() private readonly selection: SelectionModel<ListItem>

	public selected = false

	public ngOnInit() {
		this.selected = this.selection.isSelected(this.instance)

		this.selection.changed.subscribe((change: SelectionChange<ListItem>) => {
			this.selected = change.source.isSelected(this.instance)
		})
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (typeof changes.instance !== 'undefined') {
			this.selected = this.selection.isSelected(changes.instance.currentValue)
		}
	}

	public handleCheckChange = (checked: boolean) => {
		this.handleToggle.emit({ instance: this.instance, checked })
	}
}
